import React from 'react'
import Img from 'gatsby-image'
import { StaticQuery, graphql } from "gatsby"

export default () => (
  <StaticQuery
    query={graphql`
        query {
            imageSharp(fluid: { originalName: {regex: "/LogoMach3_Texte.png/" }}) {
                fluid {
                  ...GatsbyImageSharpFluid_tracedSVG
                }
            }
        }
      `}

    render={data =>
      <a target="_blank" rel='noopener noreferrer' href='https://www.mach3triathlon.fr'>
        <Img
          fluid={data.imageSharp.fluid}
          style={{
            position: "absolute",
            width: "15%",
            //height: "7.5%",
            right: 20,
            top: 10,
            zIndex: 19
          }}
        />
      </a>}
  />
)
